<script lang="ts">
	import { PUBLIC_ENVIRONMENT } from '$env/static/public';
	import ManageSubscription from './ManageSubscription.svelte';
	import Perks from './Perks.svelte';
	import ResendVerificationEmailButton from '$components/ResendVerificationEmailButton.svelte';
	import MonthlyYearlyToggle from './MonthlyYearlyToggle.svelte';
	import type { User } from 'firebase/auth';
	import type { PlanInformation } from '$lib/diffusionApi';
	import { analytics } from '$lib/analytics';

	export let isMonthly: boolean = true;
	export let email: string;
	export let signUpOnSubscribe: boolean = false;
	export let subscribeWord: string = 'Upgrade to Pro';
	export let isCalloutStylingActive: boolean = false;
	export let showCallToAction: boolean;
	export let isUsersPlan: boolean;
	export let user: User | null | undefined = undefined;
	export let planInformation: PlanInformation | undefined = undefined;

	const calloutStyling: string =
		'border-cyan-300 bg-cyan-100 bg-opacity-50 dark:border-cyan-300 dark:border-opacity-25 dark:bg-cyan-900 dark:bg-opacity-25 shadow-lg';

	// Check if user is verified
	$: isEmailVerified =
		!user || user.emailVerified || user.providerData[0]?.providerId !== 'password';
</script>

<div class="flex flex-col justify-center items-center">
	<div
		class={`w-[22rem] h-[36rem] p-8 flex flex-col justify-center items-center border rounded
			${isCalloutStylingActive ? calloutStyling : 'border-primary-200 bg-primary-50 dark:border-zinc-800 dark:bg-zinc-900'}`}
	>
		<div class="w-full flex flex-row justify-between items-center">
			<div class="flex flex-row items-center gap-2">
				<div class="w-fit text-zinc-900 dark:text-zinc-200 text-xl font-semibold">Pro</div>
			</div>
			{#if isUsersPlan}
				<div class="w-fit text-xs text-zinc-600">(your current plan)</div>
			{/if}
		</div>
		<div class="h-6"></div>
		<div class="w-full flex flex-col justify-start items-start">
			<Perks planName="Plus" checkmarkColor="text-cyan-600 dark:text-cyan-400 dark:opacity-80" />
		</div>
		<div class="h-6"></div>
		{#if !isUsersPlan || !planInformation || planInformation.name !== 'Plus'}
			<MonthlyYearlyToggle bind:isMonthly />
			<div class="h-6"></div>
			<div
				class="w-full h-12 flex flex-row justify-start items-center text-cyan-600 dark:text-cyan-300"
			>
				{#if isMonthly}
					<div class="text-3.25xl font-semibold">$20</div>
					<div class="w-1"></div>
					<div class="w-10 text-xs text-zinc-600 dark:text-zinc-400">per month</div>
				{:else}
					<div class="text-3.25xl font-semibold">$16</div>
					<div class="w-1"></div>
					<div class="w-10 text-xs text-zinc-600 dark:text-zinc-400">per month</div>
					<div class="w-4"></div>
					<div class="text-xs text-zinc-500 dark:text-zinc-400 opacity-70">
						(billed $192 annually)
					</div>
				{/if}
			</div>
			<div class="h-6"></div>
		{:else}
			<!-- Empty space with same height as toggle + price section -->
			<div class="h-10"></div>
			<div class="h-6"></div>
			<div class="w-full h-12"></div>
			<div class="h-6"></div>
		{/if}
		{#if showCallToAction}
			{#if isUsersPlan}
				<ManageSubscription {email} />
			{:else if !isEmailVerified && user}
				<div class="flex flex-col items-center">
					<div class="text-sm text-amber-300 mb-3 text-center">
						Please verify your email before subscribing
					</div>
					<ResendVerificationEmailButton
						{user}
						buttonClass="w-60 h-12 flex flex-row justify-center items-center text-md font-semibold rounded shadow-lg text-zinc-900 bg-cyan-300 hover:brightness-125"
					/>
				</div>
			{:else if signUpOnSubscribe}
				<a
					class="w-60 h-12 flex flex-row justify-center items-center text-md
					font-semibold rounded shadow-lg
					text-zinc-50 bg-cyan-700 hover:brightness-125
					dark:text-zinc-900 dark:bg-cyan-300 dark:hover:brightness-125"
					href="/sign-up"
				>
					{subscribeWord}
				</a>
			{:else if isMonthly}
				<a
					class="w-60 h-12 flex flex-row justify-center items-center text-md
					font-semibold rounded shadow-lg
					text-zinc-50 bg-cyan-700 hover:brightness-125
					dark:text-zinc-900 dark:bg-cyan-300 dark:hover:brightness-125"
					href="https://buy.stripe.com/14k7vxems41c8aA7sF?prefilled_email={email}"
					target="_blank"
					on:click={() =>
						analytics.capture('subscribe_to_pro_cta_clicked', { interval: 'monthly' })}
				>
					{subscribeWord}
				</a>
			{:else}
				<a
					class="w-60 h-12 flex flex-row justify-center items-center text-md
					font-semibold rounded shadow-lg
					text-zinc-50 bg-cyan-700 hover:brightness-125
					dark:text-zinc-900 dark:bg-cyan-300 dark:hover:brightness-125"
					href="https://buy.stripe.com/4gMaEXdlLfTQ11e4zU0Fi0g?prefilled_email={email}"
					target="_blank"
					on:click={() => analytics.capture('subscribe_to_pro_cta_clicked', { interval: 'yearly' })}
				>
					{subscribeWord}
				</a>
			{/if}
		{:else}
			<div
				class="w-60 h-12 flex flex-row justify-center items-center text-md rounded text-zinc-200"
			></div>
		{/if}
	</div>
</div>
